import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import clsx from 'clsx';
import Checkbox from 'components/Checkbox/Checkbox';
import { KEYS_FIELDS_SUPPLIER_MINI } from 'constants/materialAssessment';

import MiniTableBody from './components/MiniTableBody/MiniTableBody';

import type ISelectSupplierTable from './interfaces/ISelectSupplierTable';

import styles from './scss/SelectSupplierTable.module.scss';

function SelectSupplierTable({
  headerCells, selectedItems, setSelectedItems,
  vcSuppliers, setUnSelectedItems, loadMoreVCSuppliers, hasMoreVCSuppliers,
}: Readonly<ISelectSupplierTable>) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.tableHeader}>
        {headerCells.map((cell) => (
          <div
            key={cell.id}
            className={`${styles.miniHeaderCell} ${
              cell.id === KEYS_FIELDS_SUPPLIER_MINI.CHECKBOX ? styles.checkboxColumn : ''
            }`}
          >
            {cell.id !== KEYS_FIELDS_SUPPLIER_MINI.CHECKBOX ? t(cell.label) : (
              <Checkbox
                name="unselectAll"
                checked={selectedItems?.length > 0}
                value={selectedItems?.length > 0 ? 'all' : ''}
                onChange={() => setUnSelectedItems()}
                className={clsx(styles.checkbox, [selectedItems.length === 0 && styles.disabled])}
                disabled={selectedItems.length === 0}
                isLineMark
              />
            )}
          </div>
        ))}
      </div>
      <InfiniteScroll
        dataLength={vcSuppliers?.length || 0}
        next={loadMoreVCSuppliers}
        hasMore={hasMoreVCSuppliers || false}
        loader={false}
      >
        <div className={styles.tableBodyScroll}>
          <div className={styles.tableBody}>
            <div className={styles.miniTableContainer}>
              <MiniTableBody
                vcSuppliers={vcSuppliers}
                headerCellsMini={headerCells}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
              />
            </div>
          </div>
        </div>
      </InfiniteScroll>
    </div>
  );
}

export default SelectSupplierTable;
